import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { OxypeakEnvironment } from '../models/oxypeak-environment.model';
import { Tag } from '../models/tag.interface';

// Interfaccia per la risposta paginata del backend
interface TagsResponse {
  items: Tag[];
  total: number;
}

@Injectable({
  providedIn: 'root',
})
export class TagService {
  private apiUrl = `${this.env.server.url}/tag`;
  private tagsJsonUrl = '/assets/tags.json';

  constructor(
    @Inject('env') private env: OxypeakEnvironment,
    private http: HttpClient
  ) {}

  /**
   * Ottiene tutti i tag dal backend API con ricerca lato server
   */
  getTags(search?: string): Observable<Tag[]> {
    let params = new HttpParams();

    // Aggiungi il parametro di ricerca se fornito
    if (search && search.trim()) {
      params = params.set('search', search.trim());
    }

    return this.http
      .get<TagsResponse>(this.apiUrl, { params })
      .pipe(map((response: TagsResponse) => response.items || []));
  }

  /**
   * Ottiene un singolo tag per ID dal backend API
   */
  getTag(id: string): Observable<Tag> {
    return this.http.get<Tag>(`${this.apiUrl}/${id}`);
  }

  /**
   * Ottiene tutti i tag (alias per getTags senza parametri)
   */
  getAllTags(): Observable<Tag[]> {
    return this.getTags();
  }
}
